import { All, HTTPMethod } from '../../types/enums';
import BaseAdapter from './baseAdapter';
import { AdapterInterface, BenefitResponse } from '../../types/global';
import {
  BenefitCard, BenefitCardArea, BenefitCardResponse, SnapshotWardRequest
} from '../../api-models';
import { adaptBackendFilters } from '../../utils/filters';

export default class GetBenefitCardData extends BaseAdapter<BenefitCardResponse> implements AdapterInterface {
  rawResponse: BenefitCardResponse;

  modifiedRequest: SnapshotWardRequest;

  async adaptResponse(request: { snapshot: string, liftDataId: string, wardName: string }): Promise<BenefitResponse> {
    await this.fetchApiResponse('/api/card/benefits/list', HTTPMethod.Post, this.adaptRequest(request));
    return {
      stageText: this.rawResponse.headline_text,
      cards: this.rawResponse.cards.map((card: BenefitCard) => ({
        cardKey: card.card,
        displayName: card.display_name,
        stage: card.stage,
        areas: card.areas.map((area: BenefitCardArea) => ({
          title: area.display_name,
          value: area.value,
          filters: (area.filters == null || area.filters.length <= 0) ? undefined : adaptBackendFilters(area.filters),
        })),
      })),
    };
  }

  adaptRequest(request: { snapshot: string, liftDataId: string, wardName: string }): SnapshotWardRequest {
    const liftDataId = request.liftDataId === String(All.value) ? null : Number(request.liftDataId);
    this.modifiedRequest = {
      snapshot: request.snapshot,
      lift_data_id: liftDataId,
      ward_name: request.wardName,
    };

    return this.modifiedRequest;
  }
}
